import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LcWindowSingleComponent} from "./lc/lc-window-single/lc-window-single.component";
import {LcViewImageComponent} from "./lc/lc-view-image/lc-view-image.component";
const routes: Routes = [
  { path: 'singleWindow/d/:windowId', component: LcWindowSingleComponent },
  { path: 'singleWindow/:windowCode', component: LcWindowSingleComponent },
  { path: 'viewImage',component: LcViewImageComponent},
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FormRoutingModule {}
